import styled from 'styled-components';
import { Img } from 'react-image';
import { SectionTitle, PaddedContainer } from '../common/styles';

export const BaseTitle = styled(SectionTitle)`
  position: relative;
  max-width: 449px;
  margin-top: 20px;
  ${props => (props.theme.isMobile && `
    font-size: 35px;
    line-height: 46px;
  `)};
`;

export const BaseDesc = styled.p`
  position: relative;
  max-width: 440px;
  margin-top: 20px;
  color: ${props => props.theme.bodyColor};
  font-size: 20px;
  line-height: 25px;
  text-align: left;
`;

export const BaseSection = styled.div`
  ${props => (props.theme.isMobile ? `
    order: 2;
  ` : `
    max-width: 590px;
    width: 44vw;
  `)};
`;

export const LeftSection = styled(BaseSection)`
  ${props => (props.theme.isMobile ? `
    order: 1;
  ` : `
    padding-left: 12px;
  `)};
`;

export const RightSection = styled(BaseSection)`
  ${props => (props.theme.isMobile ? `
    order: 1;
  ` : `
    order: 3;
    padding-left: 5vw;
  `)};
`;

export const BaseContainer = styled(PaddedContainer)`
  position: relative;
  display: flex;
  flex-direction: ${props => (props.theme.isMobile ? 'column' : 'row')};
  align-items: ${props => (props.theme.isMobile ? 'center' : 'normal')};

  & > .base-section {
    order: 2
    ${props => (!props.theme.isMobile && `
      max-width: 590px;
      width: 44vw;
    `)};
  }

  & > .left-section {
    order: 1;
    ${props => (!props.theme.isMobile && `
      max-width: 590px;
      width: 44vw;
      padding-left: 12px;
    `)};
  }

  & > .right-section {
    ${props => (props.theme.isMobile ? `
      order: 1;
    ` : `
      order: 3;
      max-width: 590px;
      width: 44vw;
      padding-left: 5vw;
    `)};
  }
`;

export const BaseImage = styled(Img)`
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 41vw;
    max-width: 590px;
  `)};
`;
